<div class="head-wrap">
  <a style="text-decoration: none" [routerLink]="['/library']"
    ><div
      style="
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 19%;
        padding-left: 14px;
        justify-content: flex-start;
      "
    >
      <!-- <img [width]="100" [height]="60" src="../../assets/IMP PVP Tool Icons/impLogo.png" alt="logo" /> -->

      <div class="name big-header-montserrat app-title">Pricing Tool</div>
    </div>
  </a>

  <a
    style="text-decoration: none; margin-right: 1rem"
    [routerLink]="['/library']"
  >
    <div
      style="
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 19%;
        padding-left: 14px;
        justify-content: flex-end;
      "
    >
      <img
        src="../../assets/IMP PVP Tool Icons/Vector.png"
        alt=""
        style="height: 18px; padding-right: 10px"
      />

      <div class="nav-label">Scenario Library</div>
    </div>
  </a>

  <div
    class="logo"
    style="
      display: flex;
      align-items: center;
      justify-content: center;
      justify-content: flex-start;
    "
  >
    <img
      style="mix-blend-mode: screen"
      src="../../assets/IMP PVP Tool Icons/dpLogo.svg"
      alt="dpLogo"
    />
  </div>
</div>

<mat-menu #menu="matMenu">
  <!-- give local reference and tell this is manu by assigning 'matMenu' -->
  <!-- (click)="redirect(option.route)" -->
  <a
    *ngFor="let option of options"
    [routerLinkActive]="['active2']"
    [routerLink]="[option.route]"
    mat-menu-item
    [ngClass]="{
      disabled: option.disabled
    }"
  >
    <!-- <mat-icon>dialpad</mat-icon> -->
    <span> {{ option.name }} </span>
  </a>
  <!-- <button mat-menu-item disabled>
  <mat-icon>voicemail</mat-icon>
  <span>Check voicemail</span>
</button>
<button mat-menu-item>
  <mat-icon>notifications_off</mat-icon>
  <span>Disable alerts</span>
</button> -->
</mat-menu>
